import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {BrowserModule, provideClientHydration, withNoIncrementalHydration} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {AddTokenInterceptor} from "./interceptors/add-token.interceptor";
import {ErrorToastInterceptor} from "./interceptors/error-toast.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      // скролл к верху при навигации — иначе при смене slug калькулятора
      // (тот же компонент) страница остаётся на месте и пользователь не видит новый калькулятор
      withInMemoryScrolling({scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'})),
    importProvidersFrom(BrowserModule),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideClientHydration(withNoIncrementalHydration()),
    {useClass: AddTokenInterceptor, provide: HTTP_INTERCEPTORS, multi: true},
    // тост на упавший запрос (раньше был написан, но не подключён — ошибки молча глотались)
    {useClass: ErrorToastInterceptor, provide: HTTP_INTERCEPTORS, multi: true}
  ]
};
